import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IMicrosoft } from '../models/models'

export class CheckAuthSellerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'AuthSeller/CheckAuthSeller',
      requesterInfo,
    })
  }

  public async CheckAuth(): Promise<string[]> {
    return await this.getAsync<string[]>()
  }
}
